import * as Yup from "yup";

// Shared 6-digit TOTP schema. Strips internal whitespace and coerces
// whitespace-only input to undefined for optional consumers.
export const totpField = Yup.string()
    .transform((value) => {
        if (value == null) return value;
        const stripped = value.replace(/\s+/g, "");
        return stripped === "" ? undefined : stripped;
    })
    .matches(/^[0-9]{6}$/, "2FA token must be exactly 6 digits");
